module.exports = "/8/11-cac-van-de-thuong-gap-khi-su-dung-con-tr/index.html.9b5398e8d66b8730b73fe13cf4859166.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/32133.md
 ** module id = 576
 ** module chunks = 0
 **/